import React from "react";
import { VStack, Text, Divider, HStack, Select, Box } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { KYDInput } from "src/ui";
import {
  StepProps,
  PageLookalikeAudienceFormValues,
  buildLookalikeName,
} from "../types";

const PageSelectionStep: React.FC<StepProps> = ({
  pages,
  instagramAccounts,
}) => {
  const form = useFormContext<PageLookalikeAudienceFormValues>();

  const pageId = form.watch("pageId");
  const pageType = form.watch("pageType");
  const lookalikeRatio = form.watch("lookalike.ratio");

  const handleFacebookPageChange = (value: string) => {
    form.setValue("pageId", value);
    form.setValue("pageType", value ? "facebook" : undefined);
    if (value) {
      const selectedPage = pages.find((p) => p.id === value);
      form.setValue("pageId", value);
      form.setValue("pageName", selectedPage?.name || "");
      form.setValue(
        "lookalike.name",
        buildLookalikeName(selectedPage?.name || "", lookalikeRatio || "0-1")
      );
      form.setValue("name", `${selectedPage?.name} - Page Audience`);
    } else {
      form.setValue("pageId", "");
      form.setValue("pageName", "");
    }
  };

  const handleInstagramAccountChange = (value: string) => {
    form.setValue("pageId", value);
    form.setValue("pageType", value ? "instagram" : undefined);

    if (value) {
      const selectedAccount = instagramAccounts.find((acc) => acc.id === value);
      form.setValue("pageId", value);
      form.setValue("pageName", selectedAccount?.username || "");
      form.setValue(
        "lookalike.name",
        buildLookalikeName(
          selectedAccount?.username || "",
          lookalikeRatio || "0-1"
        )
      );
      form.setValue("pageType", "instagram");
      form.setValue("name", `${selectedAccount?.username} - Page Audience`);
    } else {
      form.setValue("pageId", "");
      form.setValue("pageName", "");
      form.setValue("pageType", undefined);
    }
  };

  return (
    <VStack spacing={6} align="stretch">
      <VStack align="stretch" spacing={4}>
        <HStack spacing={6} align="stretch">
          <Box
            flex={1}
            opacity={pageType === "instagram" ? 0.5 : 1}
            border="1px solid"
            borderColor="gray.200"
            borderRadius="md"
            p={4}
          >
            <VStack align="stretch" spacing={2}>
              <Text fontWeight="500">Facebook Page</Text>
              <Select
                placeholder="Select a Facebook Page"
                fontSize="14px"
                value={pageId}
                onChange={(e) => handleFacebookPageChange(e.target.value)}
                isDisabled={pageType && pageType === "instagram"}
                boxShadow={"sm"}
              >
                {pages.map((page) => (
                  <option key={page.id} value={page.id}>
                    {page.name}
                  </option>
                ))}
              </Select>
            </VStack>
          </Box>

          {/* Instagram Account Section */}
          <Box
            flex={1}
            opacity={pageType === "facebook" ? 0.5 : 1}
            border="1px solid"
            borderColor="gray.200"
            borderRadius="md"
            p={4}
          >
            <VStack align="stretch" spacing={2}>
              <Text fontWeight="500">Instagram Account</Text>
              <Select
                placeholder="Select an Instagram Account"
                fontSize="14px"
                value={pageId}
                onChange={(e) => handleInstagramAccountChange(e.target.value)}
                isDisabled={pageType && pageType === "facebook"}
                boxShadow={"sm"}
              >
                {instagramAccounts.map((account) => (
                  <option key={account.id} value={account.id}>
                    @{account.username}
                  </option>
                ))}
              </Select>
            </VStack>
          </Box>
        </HStack>
      </VStack>
    </VStack>
  );
};

export default PageSelectionStep;
